import React from 'react'
import { Text } from '@shopify/polaris';
import "./style.css"

const CsvDocs = () => {
    const instructions = [
        {
            key: "display_name",
            term: "Title",
            description: <p>The title of the shipping rate.</p>
        },
        {
            key: "description",
            term: "Description",
            description: <p>Description to show on checkout</p>
        },
        {
            key: "active",
            term: "Active",
            description: <p>The status of the shipping rate. Valid values: <b>Yes</b> or <b>No</b>.</p>
        },
        {
            key: "default_cost",
            term: "Base Price",
            description: <p>The cost of the shipping rate.</p>
        },
        {
            key: "shipping_by",
            term: "Shipping Area By",
            description: <p>The type of the shipping rate. Valid values: <b>zip</b>, <b>city</b>, <b>state</b>, <b>countries</b> or leave it empty.</p>
        },
        {
            key: "zip_codes",
            term: "Zip/Postal Codes",
            description: <p>A string of semicollon-separated zip/postal codes. Example: <i>10001;10002;10003</i></p>
        },
        {
            key: "cities",
            term: "Cities",
            description: <p>A string of semicollon-separated cities, Example: <i>New York;Chicago;Los Angeles</i></p>
        },
        {
            key: "states",
            term: "States",
            description: <p>A string of semicollon-separated state codes in this format <code>country_code.state_code</code>. Example: <i>US.AL;US.AK;US.AS</i></p>
        },
        {
            key: "countries",
            term: "Countries",
            description: <p>A string of semicollon-separated country codes. Example: <i>US;CA;CN</i></p>
        },
        {
            key: "exp_zip_codes",
            term: "Exceptional Zip/Postal Codes",
            description: <p>A string of semicollon-separated zip/postal codes. Example: <i>10001;10002;10003</i></p>
        },
        {
            key: "exp_cities",
            term: "Exceptional Cities",
            description: <p>A string of semicollon-separated cities, Example: <i>New York;Chicago;Los Angeles</i></p>
        },
        {
            key: "exp_states",
            term: "Exceptional States",
            description: <p>A string of semicollon-separated state codes in this format <code>country_code.state_code</code>. Example: <i>US.AL;US.AK;US.AS</i></p>
        },
        {
            key: "charge_by",
            term: "Charge Shipping By",
            description: <p>The criteria for shipping rate. Valid values: <b>price</b>, <b>weight</b>, <b>qty</b> or leave it empty.</p>
        },
        {
            key: "cost_by",
            term: "Cost By",
            description: <p>This defines how to calculate price for shipping. Valid values: <b>flat</b>, <b>qty</b> or <b>unit</b>.
                <ul>
                    <li>If <code>qty</code> is selected, price range will multiply with cart quantity.</li>
                    <li>If <code>unit</code> is selected, price range will multiply with weight according to selected weight unit.</li>
                </ul>
            </p>
        },
        {
            key: "unit",
            term: "Weight Unit",
            description: <p>The unit of weight. Valid values: <b>kg</b>, <b>lb</b>,<b>oz</b> or <b>g</b>.</p>
        },
        {
            key: "priceBy",
            term: "Flat/Percentage Price",
            description: <p>This defines how to calculate shipping price when value of <code>charge_by</code> is <i><b>price</b></i>. Valid values: <b>flat</b> or <b>percentage</b>.</p>
        },
        {
            key: "add_base_price",
            term: "Plus Base Price",
            description: <p>Whether to add base price to shipping range or not. Valid values: <b>Yes</b> or <b>No</b>.</p>
        },
        {
            key: "multiply_base_price",
            term: "Multiply Base Price with Quantity",
            description: <p>Whether to multiply shipping price to Quantity, or to weight or not. Valid values: <b>Yes</b> or <b>No</b>.</p>
        },
        {
            key: "shipping_ranges",
            term: "Price Ranges",
            description: <p>Shipping price ranges have three values, <b>from</b>, <b>upto</b> and <b>cost</b>.<br /> Format: <i>from-upto:cost|from-upto:cost|from-upto:cost</i><br />
                Examples: <i>0-10:30|0-20:40|20-30:50</i></p>
        },
        {
            key: "min_spent",
            term: "Minimum Spent",
            description: <p>Any value in numbers for minimum Spent.</p>
        },
        {
            key: "max_spent",
            term: "Maximum Spent",
            description: <p>Any value in numbers for maximum Spent.</p>
        },
    ]
    return (
        <div>{instructions.map((item, i) => {
            return <>
                <Text variant="headingMd" as="h6">
                    <span style={{ textAlign: 'right', display: 'inline-block', width: '20px', marginRight: '5px' }}>
                        {i + 1}.
                    </span>
                    {item.term}
                </Text>
                <p style={{ marginLeft: "25px", paddingRight: '10px' }}>
                    {item.description}
                </p>
            </>
        })}
        </div>
    )
}

export default CsvDocs